import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/EventsPage";
import { router } from "@/router";
import { getGlobal } from "@/functions/getGlobal";
import { stripTags } from "@/functions/stripTags";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const routerProp = router["events"];

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global["page.events.banner.title.en"]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [{ component: "EventsPageBannerSection" }, { component: "EventsPageContentSection" }],
    },
  };
}
